import { useEffect, useState } from 'react';
import api from '../services/ApiService';

function fmtDate(v) {
  if (!v) return '—';
  try { return new Date(v).toLocaleString(); } catch { return v; }
}

export default function RecordingsPanel() {
  const [recordings, setRecordings] = useState([]);
  const [loading, setLoading]       = useState(true);

  const load = async () => {
    try {
      const r = await api.getRecordings();
      setRecordings(r || []);
    } catch { /* silent */ }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const deleteRecording = async (id) => {
    if (!window.confirm('Delete this recording?')) return;
    try { await api.deleteRecording(id); await load(); } catch { alert('Failed to delete recording.'); }
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <div className="admin-page-title">Recordings</div>
          <div className="admin-page-subtitle">{recordings.length} recording{recordings.length !== 1 ? 's' : ''}</div>
        </div>
        <button className="secondary-btn small-btn" onClick={load}>↻ Refresh</button>
      </div>

      {loading && <p className="admin-muted">Loading…</p>}

      {!loading && recordings.length === 0 && (
        <div className="content-card" style={{ textAlign: 'center', padding: '48px' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>🎙️</div>
          <p className="admin-muted">No recordings yet. Use the Record button during a call.</p>
        </div>
      )}

      {!loading && recordings.map(r => (
        <div key={r.id} className="content-card" style={{ marginBottom: '12px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', marginBottom: '10px' }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: '14px', color: '#111827' }}>
                {r.original_name || r.filename}
              </div>
              <div className="admin-muted" style={{ marginTop: '2px' }}>{fmtDate(r.created_at)}</div>
            </div>
            <button
              onClick={() => deleteRecording(r.id)}
              style={{ background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: '8px', padding: '6px 12px', fontSize: '12px', fontWeight: 600, flexShrink: 0 }}
            >
              ✕ Delete
            </button>
          </div>
          <audio
            controls
            src={api.getRecordingUrl(r.url)}
            preload="metadata"
            style={{ width: '100%', borderRadius: '8px' }}
          />
        </div>
      ))}
    </div>
  );
}
